import React from 'react';
import CheckBoxField from 'customField/CheckBoxField';
import { Field, FastField } from 'formik';

/**
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {any} props.label
 * @param {string} props.classNameContainer - Class name of div that wrapping label, input and error message
 * @param {boolean} props.isFastField
 * @param {boolean} props.disabled
 * @param {boolean} props.defaultChecked
 * @param {"left" | "right"} props.positionLabel
 * @param {(event) => void} props.afterOnChange
 * @returns
 */
const Checkbox = (props) => {
  const FieldWrapper = props.isFastField ? FastField : Field;
  return <FieldWrapper component={CheckBoxField} {...props} />;
};

export default Checkbox;
